import React from 'react'
import PropTypes from 'prop-types'
import LocalPhone from '@mui/icons-material/LocalPhone'

const LocalPhoneIcon = ({ height, width, ...more }) => {
	
	return (
		<LocalPhone
			height={height}
			width={width}
			{...more}
		/>
	)
}

LocalPhoneIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default LocalPhoneIcon
